import { useMemo } from 'react';

import { Annotations, AnnotationTick } from '../../Annotations/index';

export const useAnnotationsElementMemo = ({
  chartData,
  onAnnotationHover,
  onAnnotationSelect,
  xAxisScale,
  highlightingStart,
  hoveredCategory,
  selectedCategory,
  dataKey,
}) => {
  return useMemo(() => {
    return (
      <Annotations
        tickLine={false}
        scale={xAxisScale}
        onMouseEnter={({ value }) => onAnnotationHover({ category: value })}
        onMouseLeave={() => onAnnotationHover({ category: null })}
        tick={
          <AnnotationTick
            data={chartData}
            dataKey={dataKey}
            onSelect={({ value, annotations }) =>
              onAnnotationSelect({ category: value, annotations })
            }
            highlightingStart={
              highlightingStart /*chartState.highlighting.start*/
            }
            hoveredCategory={
              hoveredCategory /*chartState.annotations.hoveredCategory*/
            }
            selectedCategory={
              selectedCategory /*chartState.annotations.selectedCategory*/
            }
          />
        }
      />
    );
  }, [
    xAxisScale,
    onAnnotationHover,
    chartData,
    dataKey,
    highlightingStart,
    hoveredCategory,
    selectedCategory,
  ]);
};
